import React from 'react';
interface GoldBowProps {
  className?: string;
  /** Stroke color. Defaults to Queen Gold. */
  color?: string;
  strokeWidth?: number;
}

/**
 * The gold delivery bow — the brand's real signature motif.
 * Single-line, stroke only, no fill. Used as a section divider mark, a bullet
 * marker, and the success icon. Never as a large illustration or repeating pattern.
 */
export function GoldBow({
  className = 'h-5 w-5',
  color = '#E8C97A',
  strokeWidth = 1.4
}: GoldBowProps) {
  return <svg viewBox="0 0 32 24" fill="none" aria-hidden="true" focusable="false" className={className} stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" data-id="element-72" data-mp="oaqbhvk5oyun">
      {/* Left loop */}
      <path d="M15 12C11.5 7.5 8.5 5.5 5.5 6.4 2.9 7.2 2.4 10.6 4.4 12.3c2 1.7 6 1.4 10.6-.3Z" data-id="element-73" data-mp="yaquthi0zeyu" />
      {/* Right loop */}
      <path d="M17 12c3.5-4.5 6.5-6.5 9.5-5.6 2.6.8 3.1 4.2 1.1 5.9-2 1.7-6 1.4-10.6-.3Z" data-id="element-74" data-mp="29o35occ7cxui" />
      {/* Knot */}
      <path d="M14.6 12a1.6 1.6 0 1 0 2.8 0 1.6 1.6 0 0 0-2.8 0Z" data-id="element-75" data-mp="1yt78gd1s20nn" />
      {/* Tails */}
      <path d="M14.4 13.4 11 20.5M17.6 13.4 21 20.5" data-id="element-76" data-mp="23rihwmo5u95c" />
    </svg>;
}